// extracted by mini-css-extract-plugin
export default {"row":"editLeaderboard_row__ZWU2D","col":"editLeaderboard_col__jbgcF","card":"editLeaderboard_card__pmUUm"};